module.exports = __webpack_public_path__ + "static/scenario2-da954e985019d6219de54caf9c16ed6f.png";